import { render, staticRenderFns } from "./CheckboxButton.vue?vue&type=template&id=8c23aa7e&scoped=true&"
import script from "./CheckboxButton.vue?vue&type=script&lang=js&"
export * from "./CheckboxButton.vue?vue&type=script&lang=js&"
import style0 from "./CheckboxButton.vue?vue&type=style&index=0&id=8c23aa7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c23aa7e",
  null
  
)

export default component.exports